/* eslint-disable */
import { connect } from "react-redux";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import Footer from "components/footer/Footer";
import ReleaseVersion from "components/footer/ReleaseVersion";

const Sidebar = ({ routes, open, onClose }) => {
  return (
    <div
      className={`sidebar-container ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 h-2.5 font-poppins text-[26px] app-name">
          BAKODE <span className="font-medium">Cert</span>
        </div>
      </div>
      <div className="mt-[55px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={routes.filter(route => route.isMainMenu)}/>
      </ul>

      <Footer />
      <ReleaseVersion/>
      {/* Nav item end */}
    </div>
  );
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
